import React, { CSSProperties } from "react";
import { Button, Header, Icon, Segment } from "semantic-ui-react";

// Utils
import { formatISOtoBEDateTime } from "react-lib/utils/dateUtils";

// Serializers
import DiagFormSerializer from "issara-sdk/types/DiagFormSerializer_apps_PRX";

const PRIMARY_COLOR = "#F382A0";

const styles = {
  sectionHeader: {
    background: PRIMARY_COLOR,
    padding: "8px 13px",
    cursor: "pointer",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "baseline",
    margin: 0,
  } as CSSProperties,
  listItem: {
    padding: "10px 9px",
    position: "relative",
    margin: 0,
    borderColor: PRIMARY_COLOR,
    border: "solid 1px #F382A0",
  } as CSSProperties,
  absoluteButton: {
    position: "absolute",
    top: "6px",
    right: "9px",
    background: PRIMARY_COLOR,
    padding: "3px 5px",
    minWidth: "16px",
    minHeight: "13px",
  } as CSSProperties,
};

type FormSectionProps = {
  forms?: DiagFormSerializer[];
  isCollapsed: boolean;
  onToggle: () => void;
};

const parseAns = (ans?: string | null): string => {
  if (!ans) return "";

  try {
    const obj = JSON.parse(ans);
    const selected = Object.values(obj).filter((item: any) => item.selected === true);

    if (selected.length === 0) return "";

    const lastItem = selected[selected.length - 1] as any;

    return lastItem.text || "";
  } catch (err) {
    console.error("Invalid JSON: ", err);
    return "";
  }
};

const FormSection: React.FC<FormSectionProps> = (props) => {
  const forms = props.forms || [];

  return (
    <Segment.Group style={{ marginBottom: "10px" }}>
      {/* Form Header */}
      <Segment inverted style={styles.sectionHeader} onClick={props.onToggle}>
        <Header as="h5" inverted style={{ margin: 0, fontSize: "13px" }}>
          แบบคัดกรอง
        </Header>
        <Icon name={props.isCollapsed ? "angle down" : "angle up"} style={{ margin: 0 }} />
      </Segment>

      {/* Form Content */}
      {!props.isCollapsed &&
        forms.map((form, formIndex) => (
          <Segment
            key={form.id}
            style={{
              ...styles.listItem,
              marginTop: formIndex === 0 ? 0 : "5px",
              borderTop: formIndex === 0 ? "none" : "solid 1px #F382A0",
              borderRadius: formIndex === 0 ? "0 0 5px 5px" : "5px",
            }}
          >
            <Button icon size="mini" style={styles.absoluteButton}>
              <Icon name="eye" style={{ color: "#FFFFFF", fontSize: "8px", margin: 0 }} />
            </Button>
            <div style={{ fontWeight: 600, fontSize: "10px", marginBottom: "5px" }}>
              {form.diag_rule_name}
            </div>
            <div style={{ fontSize: "10px", marginBottom: "3px" }}>
              วันที่ทำแบบประเมิน : {formatISOtoBEDateTime(form.updated).dateTimeShort}
            </div>
            <div style={{ fontWeight: 600, fontSize: "10px" }}>
              <span>ผลการประเมิน : </span>
              <span style={{ fontWeight: "normal" }}>{parseAns(form.answers)}</span>
            </div>
          </Segment>
        ))}
    </Segment.Group>
  );
};

export default FormSection;
